<template>
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 3V9" :stroke="color" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8.59786 4.5L3.40186 7.5" :stroke="color" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3.40186 4.5L8.59786 7.5" :stroke="color" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#FF3B30',
    },
  }
};
</script>
